import { styled } from '../../../stitches.config';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

const RadioContainer = styled('div', {});

const Label = styled('label', {
  'display': 'block',
  'padding': '$2 $4',
  'background': '$slate2',
  'borderColor': 'transparent',
  'color': '$slate12',
  'cursor': 'pointer',
  '&:hover, &:focus': {
    background: '$slate4',
  },
  '&:focus': {
    outline: 'inset 2px solid $slate7',
  },
  '&:active': {
    backgroundColor: '$slate3',
  },
  '&:disabled': {
    opacity: 0.5,
  },
});

const Radio = styled(RadioGroupPrimitive.Item, {
  opacity: 0,
  position: 'absolute',
  pointerEvents: 'none',
  [`&[data-state=checked] + ${Label}`]: {
    background: '$slate5',
  },
});

export const RadioGroup = styled(RadioGroupPrimitive.Root, {
  display: 'inline-flex',
  backgroundColor: '$slate3',
  borderRadius: '$medium',
  overflow: 'hidden',
});

type RadioGroupInputProps = RadioGroupPrimitive.RadioGroupItemProps & {
  label: string;
  id: string;
};
export const RadioGroupInput = ({ label, id, ...inputProps }: RadioGroupInputProps) => (
  <RadioContainer>
    <Radio {...inputProps} id={id} />
    <Label htmlFor={id}>{label}</Label>
  </RadioContainer>
);
